module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAFElEQVQoU2M8vaXtPwMewDgyFAAAxvcYKaCnF4MAAAAASUVORK5CYII="